var _defs, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAccount(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;stroke-linecap:round;stroke-linejoin:round;stroke-width:8.333px;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M62.5,50A12.5,12.5,0,1,1,50,37.5,12.5,12.5,0,0,1,62.5,50Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M80.833,62.5a6.875,6.875,0,0,0,1.375,7.583l.25.25A8.338,8.338,0,1,1,70.667,82.125l-.25-.25a6.931,6.931,0,0,0-11.75,4.917V87.5A8.333,8.333,0,1,1,42,87.5v-.375a6.875,6.875,0,0,0-4.5-6.292,6.875,6.875,0,0,0-7.583,1.375l-.25.25A8.338,8.338,0,1,1,17.875,70.667l.25-.25a6.931,6.931,0,0,0-4.917-11.75H12.5A8.333,8.333,0,1,1,12.5,42h.375a6.875,6.875,0,0,0,6.292-4.5,6.875,6.875,0,0,0-1.375-7.583l-.25-.25A8.338,8.338,0,1,1,29.333,17.875l.25.25A6.875,6.875,0,0,0,37.167,19.5H37.5a6.875,6.875,0,0,0,4.167-6.292V12.5a8.333,8.333,0,1,1,16.667,0v.375a6.931,6.931,0,0,0,11.75,4.917l.25-.25A8.338,8.338,0,1,1,82.125,29.333l-.25.25A6.875,6.875,0,0,0,80.5,37.167V37.5a6.875,6.875,0,0,0,6.292,4.167H87.5a8.333,8.333,0,1,1,0,16.667h-.375A6.875,6.875,0,0,0,80.833,62.5Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccount);
export default __webpack_public_path__ + "static/media/account.d5140d7368e35f8531201f5ea09f2b05.svg";
export { ForwardRef as ReactComponent };